<div class="max-w-[400px] mx-auto bg-white min-h-screen flex flex-col font-sans">
    <!-- Component Header / Logo -->
    <!-- Component Header / Logo -->
    <div class="pt-24 pb-4 text-center px-6">
        <img *ngIf="product?.organization?.logo" [src]="product?.organization?.logo" alt="Organization Logo"
            class="h-10 mx-auto object-contain">
        <img *ngIf="!product?.organization?.logo" src="assets/logos/logo-dark.svg" alt="ReGenesis"
            class="h-10 mx-auto object-contain">
    </div>

    <!-- Product Image with Stamp -->
    <div class="relative w-full h-[350px] flex items-center justify-center overflow-hidden mb-4 bg-gray-50">
        <div class="absolute inset-0 bg-gradient-to-b from-gray-100 to-white opacity-50"></div>
        <img [src]="productImage" alt="Product Image"
            class="relative z-10 w-auto h-[80%] max-w-[80%] object-contain drop-shadow-xl">

        <!-- Stamp Overlay -->
        <div class="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
            <div
                class="border-[4px] border-[#EF4444] rounded-xl transform -rotate-[15deg] px-6 py-3 bg-white/20 backdrop-blur-[2px] shadow-sm">
                <span
                    class="text-2xl md:text-3xl font-[900] text-[#EF4444] tracking-[0.2em] uppercase text-center block whitespace-nowrap">
                    Product<br>Recalled
                </span>
            </div>
        </div>
    </div>

    <!-- Info Card -->
    <div class="px-5 mb-2 relative z-30 -mt-10">
        <div
            class="bg-white rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] p-4 border border-gray-100 flex items-start gap-3">
            <i class="pi pi-info-circle text-xl text-gray-800 mt-0.5 shrink-0"></i>
            <div>
                <h2 class="text-base font-bold text-gray-900 m-0 leading-tight mb-2">The Product has been Recalled</h2>
                <p class="text-xs text-gray-500 m-0 leading-relaxed">
                    {{ recallData?.productScanMessage || 'For any questions or additional details, please fill out the
                    form below to submit your query.' }}
                </p>
            </div>
        </div>
    </div>

    <!-- Contact Form Section -->
    <div class="px-5 mb-8 flex-1">
        <div class="bg-[#FFF9F0] rounded-xl p-5 border border-[#FFE0B2]">
            <div class="flex items-start gap-3 mb-5">
                <i class="pi pi-info-circle text-lg text-gray-900 mt-0.5 shrink-0"></i>
                <div>
                    <h3 class="text-sm font-bold text-gray-900 m-0 mb-1">The Product has been Recalled</h3>
                    <p class="text-[11px] text-gray-600 m-0 leading-relaxed">
                        For any questions or additional details, please fill out the form below to submit your query.
                    </p>
                </div>
            </div>

            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-3">
                <!-- Contact Button (Phone) -->
                <a href="https://www.regenesis.ag/contact-us" target="_blank"
                    class="w-full bg-[#FFC107] hover:bg-[#FFB300] text-gray-900 font-bold py-3.5 rounded-lg border-none cursor-pointer flex items-center justify-center gap-2 transition-all shadow-sm active:scale-[0.98] no-underline">
                    <i class="pi pi-phone font-bold"></i>
                    Contact Us
                </a>

                <!-- OR divider could go here if needed -->


            </form>
        </div>
    </div>

    <!-- Footer -->
    <div class="mt-auto">
        <app-footer *ngIf="footerContent" [content]="footerContent" [styles]="footerContent.styles"
            [isFirstModule]="false" [isLastModule]="false" [isSelectedModule]="false">
        </app-footer>
    </div>
</div>